import { render, staticRenderFns } from "./avptIndex.vue?vue&type=template&id=1cee634e"
import script from "./avptIndex.vue?vue&type=script&lang=js"
export * from "./avptIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports